import React, { useState } from "react"
import PropTypes from "prop-types"
//i18n
import { withTranslation } from "react-i18next"

//Import Breadcrumb
import { PageContent, CustomBreadcrumb } from "components/Common"

import CardDetail from "./CardDetail"
import { ModuleIds } from "constant"

const RESOURCE = ModuleIds.Test

const DetailContainer = ({ isEdit, t }) => {
    const titleTag = `Profile Detail`
    const [sticky, setSticky] = useState(false);
    return (
        <PageContent title={titleTag}>
            <CustomBreadcrumb
                breadcrumbItem={t("Profile List")}
                resource={RESOURCE}
                onSticky={(e) => {
                    setSticky(e)
                }}
                isDetail
            />
            <CardDetail isEdit={isEdit} sticky={sticky} />
        </PageContent>
    )
}

DetailContainer.propTypes = {
    t: PropTypes.any,
    isEdit: PropTypes.bool,
}

export default withTranslation(["testProfilePage"])(DetailContainer)
